import api from '@mint-lib/api';
import { useCrucialQuery } from '@mint-lib/query-client';
import { getRouteApi } from '@mint/routing';

import { queryClient } from '../api/queries/client.js';
import { GET_BUILDER_TABLE_VIEW } from '../constants/EndpointConstants.js';
import { QueryKey } from '../constants/queryKeys.js';
import {
  BuilderTableViewResponse,
  BuilderTableViewResponseSchema,
} from '../types/builderTableView.js';
import { getNestedValue, NestedKeyOf } from '../utils/helpers.js';

const getBuilderTableViewData = async (campaignId: string) => {
  const response = await api.get(GET_BUILDER_TABLE_VIEW, {
    params: {
      campaign_collection: campaignId,
    },
  });

  return BuilderTableViewResponseSchema.parse(response.data);
};

const routeApi = getRouteApi(
  '/_secured/campaign/$campaignId/planning/buying-plan',
);

export const useGetBuilderTableViewData = () => {
  const params = routeApi.useParams();

  const { data, isLoading, isError, refetch } = useCrucialQuery({
    queryKey: [QueryKey.BUILDER_TABLE_VIEW, params.campaignId],
    queryFn: () => getBuilderTableViewData(params.campaignId),
    enabled: !!params.campaignId,
    staleTime: Infinity,
  });

  return { data, isLoading, isError, refetch };
};

export const useBuilderTableViewDataSelector = <
  K extends NestedKeyOf<BuilderTableViewResponse>,
>(
  path: K,
) => {
  const params = routeApi.useParams();
  const data = queryClient.getQueryData<BuilderTableViewResponse>([
    QueryKey.BUILDER_TABLE_VIEW,
    params.campaignId,
  ]);

  return { data: data ? getNestedValue(data, path) : undefined };
};
